var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switcher",class:{
        'overview': _vm.activeRoute === 'Overview',
        'details': _vm.activeRoute === 'Details',
    }},[_c('ul',[_c('router-link',{staticClass:"overview",attrs:{"to":{ name: 'Overview' },"tag":"li"},on:{"click":function($event){_vm.activeRoute = 'Overview'}}},[_vm._v("Tribe overview")]),_c('router-link',{staticClass:"details",attrs:{"to":{ name: 'Details' },"tag":"li"},on:{"click":function($event){_vm.activeRoute = 'Details'}}},[_vm._v("My tribe's details")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }